/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "idmatch": {
        "nested": {
          "service": {
            "nested": {
              "Source": {
                "values": {
                  "SOURCE_DO_NOT_USE": 0,
                  "SOURCE_UNKNOWN": 1,
                  "GDC_RESIDENT_FILES": 2,
                  "GDC_PASSPORT_MRZ_VALIDATION": 3,
                  "GDC_CONSUMER": 4,
                  "GDC_JP_COMMUNITY": 5,
                  "GDC_PUBLIC": 6,
                  "GDC_UTILITY": 7,
                  "GDC_CANADA_CREDIT_AGENCY": 8,
                  "GDC_CANADIAN_CITIZEN_FILE": 9,
                  "GDC_ENHANCED_CREDIT_1": 10,
                  "GDC_EUROPEAN_TELEPHONE_DIRECTORY": 11,
                  "GDC_INSEE_NUMBER_VALIDATION": 12,
                  "GDC_UK_DIRECTORY_SEARCH": 13,
                  "GDC_UK_ELECTORAL_ROLL": 14,
                  "GDC_NHS_VALIDATION": 15,
                  "GDC_TRACESMART_REGISTER": 16,
                  "GDC_UK_OTHER": 17,
                  "GDC_ELECTORAL_ROLL": 18,
                  "GDC_UK_CREDIT": 19,
                  "GDC_UK_NI_NUMBER_VALIDATION": 20,
                  "GDC_UK_PUBLIC_RECORD": 21,
                  "GDC_UK_DRIVER_LICENSE_VALIDATION": 22,
                  "GDC_CREDIT_AGENCY": 23,
                  "GDC_CREDIT_AGENCY_2": 24,
                  "GDC_ELECTORAL_ROLL_2": 25,
                  "TRACESMART_DIRECTOR": 26,
                  "TRACESMART_ELECTORAL_ROLL": 27,
                  "TRACESMART_EQUIFAX": 28,
                  "TRACESMART_EXPERIAN": 29,
                  "TRACESMART_INSOLVENCY_SERVICE": 30,
                  "TRACESMART_REGISTRY_TRUST": 31,
                  "TRACESMART_ROLLING_REGISTER": 32,
                  "TRACESMART_SCOTTISH_LR": 33,
                  "TRACESMART_SHAREHOLDER": 34,
                  "TRACESMART_TELEPHONE": 35,
                  "TRACESMART_TRACESMART": 36,
                  "UK_DIRECTORY_SEARCH": 37,
                  "TRACESMART_ADDITIONAL_CREDIT_ACTIVE": 38
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.idmatch?.nested?.service?.nested?.Source) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Source @ squareup/idmatch/service.proto at 17:1
 */
export const Source = $root.lookupEnum('squareup.idmatch.service.Source').values;